import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { useState } from 'preact/hooks';
import { ViewAvailableDropOffLocationModal } from '../ViewAvailableDropOffLocationModal';
import {
  Title,
  SubText,
  Container,
} from './ViewAvailableDropOffLocationContainer.styles';

interface ViewAvailableDropOffLocationContainerProps {
  carrierId: string;
}

export const ViewAvailableDropOffLocationContainer = ({
  carrierId,
}: ViewAvailableDropOffLocationContainerProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Container>
      <Title>{t('RETURN_VIEW_AVAILABLE_DROPOFF_TITLE')}</Title>
      <SubText>{t('RETURN_VIEW_AVAILABLE_DROPOFF_SUBTEXT')}</SubText>
      <Button block variant="fulfilled" onClick={() => setIsOpen(true)}>
        {t('RETURN_VIEW_AVAILABLE_DROPOFF_LOCATIONS_CTA')}
      </Button>
      <ViewAvailableDropOffLocationModal
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        carrierId={carrierId}
      />
    </Container>
  );
};
